import { defaultListInitialState } from 'utils';
import config from 'config';
import { createBookUrl } from 'partners/embed';

function createCompanySelector(reducer, name = 'items') {
  return companyId => state => {
    const item = state.profile.companies[reducer][companyId];
    return item ? item[name] : defaultListInitialState[name];
  };
}

export const companiesSelector = (state) => state.profile.companies.companies.items;
export const  companiesIsFetchingSelector = (state) =>
  state.profile.companies.companies.isFetching;
export const companySelector = (state) => state.profile.companies.company.data;
export const bikesSelector = createCompanySelector('bikes');
export const allBikesSelector = (state) => state.profile.companies.bikes;
export const extrasSelector = (state) => state.profile.companies.extras.items;
export const bookingsSelector = (state) => state.profile.companies.bookings.items;
export const leaveLocationsSelector = (state) => state.profile.companies.leaveLocations.items;
export const reservationsSelector = (state) => state.profile.companies.reservations.items;
export const seasonsSelector = createCompanySelector('seasons');
export const allSeasonsSelector = (state) => state.profile.companies.seasons;

export const tariffsSelector = (state) => state.profile.companies.tariffs.items;
export const tariffsSourceSelector = (state) => state.profile.companies.tariffsSource.items;
export const profileTimelineBookingsSelector = (state) =>
  state.profile.companies.timelineBookings;
export const profileBookingsSelector = (state) => state.profile.bookings.items;
export const isModeratorSelector = (state) =>
  !!state.profile.profile && !!state.profile.profile.isModerator;

// integrations
const selectAppDomain = state => {

  // TODO: this should better be inside state
  const {
    appDomain
  } = config;

  return appDomain;
};

export const selectAPIUrl = state => {
  const company = companySelector(state);

  if (company == null) {
    return '';
  }
  const {
    i18n: {
      language
    }
  } = state;

  // select protocol based on external site protocol
  return `//${selectAppDomain(state)}/${language}/static/embed/api.js?autowire=yes&company=${company.id}`;
};

export const selectAPIInjectionCode = state => `<!-- ${selectAppDomain(state)} integration API do not remove -->
<script type="text/javascript" src="${selectAPIUrl(state)}"></script>`;

export const selectBookButton = state => state.profile.integrations;

export const selectBookButtonCode = state => {
  const button = selectBookButton(state);
  const tag = {
    link(button, state) {
      const company = companySelector(state);
      if (company == null) {
        return '';
      }

      const {
        appDomain,
        appProtocol
      } = config;

      const {
        i18n: {
          language
        }
      } = state;

      const href = createBookUrl({
        base: `${appProtocol}://${appDomain}/`,
        locale: language,
        company: company.id
      });

      return `<a href="${href}" target="_blank" class="bikesbooking-connect">${button.label}</a>`;
    },
    button(button, state) {
      return `<button type="button" class="bikesbooking-connect">${button.label}</button>`;
    }
  };

  return tag[button.type](button, state);
};



// WEBPACK FOOTER //
// ./src/selectors/profile.js